// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth_Auth__Z6ofE {
  width: 100%;
  height: 100vh;
  background: #F0F2F5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Auth_Auth__Z6ofE .Auth_logo__hulvj {
  margin-bottom: 64px;
}
.Auth_Auth__Z6ofE .Auth_authForm__NT4r7 {
  width: 330px;
  border-radius: 2px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
}
.Auth_Auth__Z6ofE .Auth_authForm__NT4r7 .Auth_header__exxa7 {
  width: 100%;
  text-align: center;
  margin-bottom: 24px;
}
.Auth_Auth__Z6ofE .Auth_authForm__NT4r7 .Auth_forgot_password__dgUoB {
  width: 100%;
  color: #00A899 !important;
  text-align: right;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/authorization/Auth/Auth.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAGE;EACE,YAAA;EAEA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AAFN;AAKI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AAHN","sourcesContent":[".Auth {\n  width: 100%;\n  height: 100vh;\n  background: #F0F2F5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .logo{\n    margin-bottom: 64px;\n\n  }\n\n  .authForm {\n    width: 330px;\n    //height: 314px;\n    border-radius: 2px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    background: #FFFFFF;\n\n    .header {\n      width: 100%;\n      text-align: center;\n      margin-bottom: 24px;\n    }\n\n    .forgot_password {\n      width: 100%;\n      color: #00A899!important;\n      text-align: right;\n      margin-bottom: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Auth": `Auth_Auth__Z6ofE`,
	"logo": `Auth_logo__hulvj`,
	"authForm": `Auth_authForm__NT4r7`,
	"header": `Auth_header__exxa7`,
	"forgot_password": `Auth_forgot_password__dgUoB`
};
export default ___CSS_LOADER_EXPORT___;
